const activity = {
  activity: "गतिविधि", // translated 
  activities: "गतिविधियाँ", // translated 
  dates: "खजूर", // translated 
  location: "जगह", // translated 
  languages: "बोली", // translated 
  categories: "श्रेणियाँ", // translated 
  ticketOption: "टिकट विकल्प", // translated 
  numberOfRatings: "रेटिंग की संख्या", // translated 
  meetingPointInfo: "मीटिंग स्थल की जानकारी", // translated 
  meetingPoint: "बैठक बिंदु", // translated 
  meetingPoints: "बैठक स्थल", // translated 
  providedBy: "द्वारा उपलब्ध कराया गया", // translated 
  expirationDate: "समाप्ति तिथि", // translated 
  groupSize: "समूह का आकार", // translated 
  features: "विशेषताएँ", // translated 
  basedOn: "पर आधारित", // translated 
  reviewsFromVerCustomers: "सत्यापित ग्राहकों की समीक्षाएँ", // translated 
  excellent: "उत्कृष्ट", // translated 
  great: "महान", // translated 
  average: "औसत", // translated 
  poor: "गरीब", // translated 
  bad: "खराब", // translated 
  onlyBookedCustomersTooltip:
    "इस गतिविधि को बुक करने वाले ग्राहक ही समीक्षा छोड़ सकते हैं।", // translated 
  noReviewsYet: "फिलहाल, इस गतिविधि के लिए कोई समीक्षा उपलब्ध नहीं है।", // translated 
  backToActivitiesList: "गतिविधियों की सूची पर वापस जाएँ", // translated 
  getPrices: "कीमतें प्राप्त करें", // translated 
  availabilityAndPrices: "उपलब्धता और कीमतें", // translated 
  ticketOptions: "टिकट विकल्प", // translated 
  ticketInfo: "टिकट की जानकारी", // translated 
  selectYourTickets: "अपने टिकट चुनें", // translated 
  product: "उत्पाद", // translated 
  total: "कुल", // translated 
  slot: "छेद", // translated 
  language: "भाषा", // translated 
  tickets: "टिकट", // translated 
  ticketsFor: "टिकटों के लिए", // translated 
  previousStep: "पिछला चरण", // translated 
  onlyAvailableInEnglish: "केवल अंग्रेजी में उपलब्ध है", // translated 
  guest: "अतिथि", // translated 
  leadGuest: "मुख्य अतिथि", // translated 
  adult: "वयस्क", // translated 
  child: "बच्चा", // translated 
  pleaseSelectAdult: "कृपया कम से कम एक वयस्क का चयन करें", // translated 
  notAvailableActivity: "यह प्रोडक्ट उपलब्ध नहीं है", // translated 
  required: "आवश्यक", // translated 
  pickupPoint: "पिक अप बिंदु", // translated 
  pickupPoints: "पिकअप पॉइंट्स", // translated 
  ticketType: "टिकिट का प्रकार", // translated 
  anonymous: "गुमनाम", // translated 
  printedVoucher: "प्रिंटेड वाउचर स्वीकार्य है", // translated 
  mobileVoucher: "मोबाइल वाउचर स्वीकार्य है", // translated 
  mixedVoucher: "मोबाइल या प्रिंटेड वाउचर स्वीकार्य हैं।", // translated 
  safetyMeasures: "सुरक्षा उपाय लागू किए गए", // translated 
  doThisBecause: "ऐसा इसलिए करें क्योंकि", // translated 
  safetyInfo: "सुरक्षा जानकारी", // translated 
  reviewsHighestFirst: "समीक्षाओं की संख्या (सबसे अधिक पहले)", // translated 
  bookingFee: "बुकिंग शुल्क", // translated 
  startDate: "आरंभ करने की तिथि", // translated 
  endDate: "अंतिम तिथि", // translated 
  cancellationDeadlineAndFees: "रद्द करने की समय सीमा और शुल्क", // translated 
  resetTickets: "टिकट रीसेट करें", // translated 
  instantConfirmation: "त्वरित पुष्टि", // translated 
  clickResetBtn: "अपना चयन पुनः शुरू करने के लिए रीसेट बटन पर क्लिक करें।", // translated 
  whatToRemember: "क्या याद रखना चाहिए", // translated 
};


export default activity;
